import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=bb7c8688&scoped=true&"
import script from "./VendorList.vue?vue&type=script&lang=js&"
export * from "./VendorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7c8688",
  null
  
)

export default component.exports